import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { AddressEffects } from "./effects/address-tree.effects";
import { AreaEffects } from "./effects/area.effects";
import { BuildingEffects } from "../components/shared-components/state/effects/building.effects";
import { CardEnvironmentEffects } from "./effects/card-environment.effects";
import { CardProgrammerEffects } from "./effects/card-programmer.effects";
import { ChartEffects } from "./effects/chart.effects";
import { ClientSettingsEffects } from "./effects/client-settings.effects";
import { DeviceCardEffects } from "./effects/device-card.effects";
import { EnvironmentEffects } from "./effects/environment.effects";
import { GatewayEffects } from "./effects/gateway.effects";
import { HistoryTransitEffects } from "./effects/history-transit.effects";
import { LocalStorageEffects } from "./effects/local-storage.effects";
import { NotificationEffects } from "./effects/notification.effects";
import { PlantCodeEffects } from "./effects/plant-code.effects";
import { PlantEffects } from "./effects/plant.effects";
import { ServerSettingsEffects } from "./effects/server-settings.effect";
import { TimeSlotEffects } from "./effects/time-slot.effects";
import { TranslationEffects } from "./effects/translation.effects";
import { metaReducers } from "./meta-reducers";
import { StorageSyncEffects } from "./meta-reducers/ionic-storage-sync-meta-reducer";
import { AppReducers } from "./reducers";
import { ScenarioEffects } from "./effects/scenario.effects";
import { ScenarioCommandsEffects } from "./effects/scenario-commands.effects";
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(AppReducers, {
      metaReducers: metaReducers,
      initialState: {
        hydrated: false,
      },
    }),
    // Instrumentation must be imported after importing StoreModule (config is optional) //
    StoreDevtoolsModule.instrument({
      maxAge: 50, // Retains last 25 states
      // logOnly: environment.production, // Restrict extension to log-only mode
      logOnly: false,
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      connectInZone: true, // Required since NgRx 17: run the devtools connection inside the Angular zone
    }),
    EffectsModule.forRoot([
      LocalStorageEffects,
      StorageSyncEffects,
      PlantEffects,
      ClientSettingsEffects,
      ServerSettingsEffects,
      NotificationEffects,
      GatewayEffects,
      AreaEffects,
      ChartEffects,
      EnvironmentEffects,
      TranslationEffects,
      TimeSlotEffects,
      DeviceCardEffects,
      HistoryTransitEffects,
      CardEnvironmentEffects,
      AddressEffects,
      CardProgrammerEffects,
      PlantCodeEffects,
      BuildingEffects,
      ScenarioEffects,
      ScenarioCommandsEffects,
    ]),
  ],
})
export class AppStoreModule { }
